
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 240","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M171 145H69c-2.5 0-4 2-4 4 0 2.5 2 4 4 4h102c2.5 0 4-2 4-4 .5-2-1.5-4-4-4m0-29H69c-2.5 0-4 2-4 4 0 2.5 2 4 4 4h102c2.5 0 4-2 4-4 .5-2.5-1.5-4-4-4m0-29.5H69c-2.5 0-4 2-4 4 0 2.5 2 4 4 4h102c2.5 0 4-2 4-4 .5-2-1.5-4-4-4M120 20C65 20 20 65 20 120s45 100 100 100 100-45 100-100S175 20 120 20m0 191.5c-50.5 0-91.5-41-91.5-91.5s41-91.5 91.5-91.5 91.5 41 91.5 91.5-41 91.5-91.5 91.5","fill-rule":"nonzero"}})])
          )
        }
      }
    